<template>
  <div class="c-collapsible"
       :class="{open: isOpenMenu}"
       ref="collapsible">
    <div @click="toggle" class="collapsible__toggle">
      <slot name="toggle"/>
    </div>
    <transition name="slide-fade">
      <div v-show="isOpenMenu"
           class="collapsible__body"
           :class="{open: isOpenMenu}">
        <slot name="body"/>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isOpenMenu: this.isOpen,
    };
  },
  methods: {
    toggle() {
      this.isOpenMenu = !this.isOpenMenu;
    },
    close() {
      // для закрытия из родительского компонента вызвать this.$refs.collapsible.close();
      this.isOpenMenu = false;
    },
    open() {
      this.isOpenMenu = true;
    },
  }
};
</script>

<style>
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
</style>